import React from 'react';
import '../styles/GammaPanel.css';

const VolumeSpikePanel = ({ gammaData }) => {
  const volumeAlerts = gammaData?.volumeAlerts ?? [];
  if (volumeAlerts.length === 0) return null;

  return (
    <div className="gamma-panel">
      <div className="gamma-vol-alerts">
        <div className="gamma-vol-alerts-title">Volume Spikes</div>
        <table className="gamma-vol-table">
          <thead>
            <tr>
              <th>Strike</th>
              <th>Type</th>
              <th>Volume</th>
              <th>Ratio</th>
              <th title="Premium change over the last ~30 min">Price % (30m)</th>
              <th title="OI change over the last ~30 min">OI Chg (30m)</th>
              <th>Signal</th>
              <th>Bias</th>
            </tr>
          </thead>
          <tbody>
            {volumeAlerts.map((a, i) => (
              <tr key={i} className={`gamma-vol-row gamma-vol-${a.sentiment?.toLowerCase()}`}>
                <td className="gamma-vol-strike">{a.strikePrice}</td>
                <td className={a.optionType === 'CE' ? 'gamma-vol-ce' : 'gamma-vol-pe'}>{a.optionType}</td>
                <td>{a.volume != null ? (a.volume / 1000).toFixed(1) + 'K' : '-'}</td>
                <td className="gamma-vol-ratio">{a.volumeRatio != null ? a.volumeRatio.toFixed(1) + '×' : '-'}</td>
                <td style={{ color: a.priceChange > 0 ? '#00c853' : a.priceChange < 0 ? '#d32f2f' : '#888' }}>
                  {a.priceChange != null ? (a.priceChange > 0 ? '+' : '') + a.priceChange.toFixed(1) + '%' : '-'}
                </td>
                <td style={{ color: a.oiChange > 0 ? '#1565c0' : a.oiChange < 0 ? '#e65100' : '#888' }}>
                  {a.oiChange != null ? (a.oiChange > 0 ? '+' : '') + (a.oiChange / 1000).toFixed(1) + 'K' : '-'}
                </td>
                <td className="gamma-vol-signal">{a.signal}</td>
                <td>
                  <span className={`gamma-vol-sentiment gamma-vol-sentiment-${a.sentiment?.toLowerCase()}`}>
                    {a.sentiment}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VolumeSpikePanel;
